import { FormattedMessage } from 'react-intl';

import messages from './AwaitingFundsView.messages';
import { AwaitingFundsIllustrationSVG } from '../../../svgComponents/awaitingFundsIllustrationSVG';
import { StateView } from '../../pageStructure/stateView/StateView';

export const AwaitingFundsView = () => {
    return (
        <StateView
            image={<AwaitingFundsIllustrationSVG />}
            headerMessage={<FormattedMessage {...messages.title} />}
            descriptionMessage={<FormattedMessage {...messages.subtitle} />}
        />
    );
};
